module.exports = __webpack_public_path__ + "img/icon_self_appointed_role.5283136c.svg";